import { render } from "./Terms.vue?vue&type=template&id=01c67487&scoped=true"
const script = {}

import "./Terms.vue?vue&type=style&index=0&id=01c67487&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c67487"]])

export default __exports__